export class Contract {
  region_rid: number;
  region_name___ru: string;
  region_name___kz: string;
  contract_rid: number;
  contract_number: string;
  contract_date: Date | string;
}
